import React, { useState } from 'react';
import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Button,
  Heading,
  Text,
} from '@chakra-ui/react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { signInStart,signInSuccess,signInFailure } from '../redux/userSlice';
import {  useDispatch } from 'react-redux';
import { backendurl } from '../path';
const LoginClerk = () => {
const Navigate = useNavigate();
const dispatch = useDispatch();
  const [email, setemail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  
  const handleLogin = async() => {
      try {
          dispatch(signInStart());
          const response  = await axios.post(`${backendurl}/login-clerk`,{"email":email,"password":password});
          dispatch(signInSuccess(response.data));
        console.log(response.data.isAuthenticated);
          
    if (response.data.isAuthenticated) {
       Navigate('/dashboard');
    }
    else{
        setErrorMessage("wrong credentials");
    }
} catch (error) {
    console.log("error from login",error);
    dispatch(signInFailure(error));

}
    }

  

  return (
    <Flex align="center" justify="center" height="100vh" m={4}>
      <Box width="400px" >
        <Box textAlign="center">
          <Heading>Login Clerk</Heading>
        </Box>
        <FormControl mt={4} isRequired>
          <FormLabel>Email</FormLabel>
          <Input
            type="text"
            placeholder="Enter here..."
            value={email}
            onChange={(e) => setemail(e.target.value)}
          />
        </FormControl>
        <FormControl mt={4} isRequired>
          <FormLabel>Password</FormLabel>
          <Input
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </FormControl>
        {errorMessage && (
          <Text color="red" mt={2} fontSize="sm">
            {errorMessage}
          </Text>
        )}
        <Button colorScheme="orange" width="full" mt={4} onClick={handleLogin}>
          Log in
        </Button>
      </Box>
    </Flex>
  );
};

export default LoginClerk;